// Textes web français de Vivre ensemble (golf 8). Même forme que samenApp.nl.ts. Calme et adulte :
// jamais « dette », « corvées », « points » ni étoiles.
export const appSamenFr = {
    words: {
        dinnerTitle: 'Qui mange ce soir ?',
        dinnerTitleCohousing: 'Repas commun',
        costsTitle: 'Partager les frais',
        costsTitleCohousing: 'Frais communs',
        costsTitleCouple: 'Payer ensemble',
        costsTitleTwoHome: 'Frais pour les enfants',
        emptyStudent: 'Personne pour l’instant. Croque-monsieur ce soir ?',
        emptyShared: 'Personne n’est encore inscrit.',
        emptyCohousing: 'Pas encore d’inscriptions.',
        formerShared: 'Ancien colocataire',
        formerCohousing: 'Ancien habitant',
        formerFamily: 'Ancien membre de la famille',
    },
    nav: {
        dinner: 'Qui mange',
        dinnerCohousing: 'Repas commun',
        bookings: 'Réservations',
        costs: 'Frais',
    },
    common: {
        save: 'Enregistrer',
        cancel: 'Annuler',
        close: 'Fermer',
        saved: 'Enregistré',
        you: 'toi',
        left: '(parti)',
        undo: 'Oups',
        moreActions: 'Plus',
    },
    dinner: {
        intro: 'Qui mange ce soir, qui cuisine et jusqu’à quelle heure s’inscrire.',
        emptyTitle: 'Manger ensemble ?',
        emptyBody: 'Choisis une heure limite et qui cuisine.',
        start: 'Lancer la liste des repas',
        started: 'La liste des repas est prête.',
        tonight: 'Ce soir',
        headCook: 'en cuisine : {name}',
        headNoCook: 'personne en cuisine',
        eaters: 'Convives : {n}',
        guestsExtra: '(+{n} invité)',
        until: 'Inscription jusqu’à {time} (encore {left})',
        closed: 'Inscriptions closes. Demande à {name}.',
        closedNoCook: 'Inscriptions closes.',
        openForYou: 'L’heure limite est passée, mais tu peux encore modifier la liste.',
        noDinner: 'Pas de dîner commun aujourd’hui',
        notDinnerDay: 'Pas de dîner commun ce jour-là.',
        myChoice: 'Mon choix',
        imIn: 'Je mange',
        imOut: 'Non',
        noChoice: '—',
        guests: 'Invités',
        guestsHint: 'Seulement le nombre ; pas de noms.',
        groupIn: 'Mange',
        groupOut: 'Ne mange pas',
        groupUnknown: 'Pas encore choisi',
        sourceDefault: 'habituel',
        sourceHouse: 'réglage de la maison',
        sourceAway: 'absent',
        sourceBoard: 'via le tableau',
        sourceBy: 'indiqué par {name}',
        sourceCook: 'cuisine',
        setFor: 'Pour {name}',
        cookTitle: 'Cuisine',
        cookClaim: 'Je cuisine',
        cookOther: 'Quelqu’un d’autre cuisine',
        cookRotation: 'Retour au planning',
        cookPick: 'Qui cuisine ?',
        cookFromRotation: 'selon le planning',
        noDinnerSet: 'Pas de dîner commun aujourd’hui',
        noDinnerUndo: 'Dîner commun finalement',
        note: 'Note de la personne en cuisine',
        noteHint: 'Tout le monde à la maison le voit, mais pas sur le tableau.',
        meal: 'Au menu : {title}',
        groceries: 'Saisir les courses',
        listChanged: 'Liste des repas modifiée · Répartir à nouveau',
        settings: 'Réglages de la liste des repas',
        cutoff: 'Inscription jusqu’à',
        cutoffHint: 'Entre 10:00 et 21:00.',
        days: 'Jours avec dîner commun',
        houseDefault: 'Celles et ceux qui n’ont rien choisi',
        houseDefaultUnknown: 'Demander',
        houseDefaultIn: 'Mange',
        houseDefaultOut: 'Ne mange pas',
        remind: 'Rappel avant l’heure limite',
        remindOff: 'Désactivé',
        remindMinutes: '{n} min',
        remindHours: '{n} h',
        cookItem: 'Tâche cuisine du planning',
        cookItemNone: 'Aucune (à prendre soi-même)',
        myDefault: 'Mon habitude',
        myDefaultHint: 'Par jour de la semaine. Un choix pour un jour précis l’emporte toujours.',
        prefIn: 'Oui',
        prefOut: 'Non',
        prefAsk: 'Me demander',
        signedIn: '{name} mange',
        signedOut: '{name} ne mange pas',
        cleared: 'Choix retiré',
        closedToast: 'Les inscriptions sont closes.',
        widgetAll: 'Vers la liste des repas',
        widgetNotYet: 'Tu n’as pas encore choisi.',
        widgetYouIn: 'Tu manges',
        widgetYouOut: 'Tu ne manges pas',
    },
    costs: {
        visibleAll: 'Tout le monde à la maison voit les dépenses et les soldes. Aucun argent ne passe par AMUMIN.',
        visibleTwoHome: 'Seuls les parents voient ceci. Les enfants ne voient rien. Aucun argent ne passe par AMUMIN. Quelque chose n’apparaît sur le tableau que si tu le confirmes toi-même expressément pour une tablette ; tu peux toujours le retirer.',
        tabExpenses: 'Dépenses',
        tabBalance: 'Solde',
        tabSettled: 'Réglé',
        add: 'Dépense',
        empty: 'Pas encore de dépenses.',
        emptyBody: 'Saisis une dépense ; AMUMIN calcule qui reçoit quoi.',
        rowPaid: 'payé par {name}',
        rowFor: 'pour {n}',
        new: 'nouveau',
        edited: 'modifié',
        questionBadge: 'question ouverte',
        locked: 'clôturé',
        loadMore: 'Charger plus',
        deletedList: 'Supprimées ({n})',
        deletedHint: 'Encore 30 jours pour les restaurer.',
        newTitle: 'Nouvelle dépense',
        editTitle: 'Modifier la dépense',
        amount: 'Montant',
        amountHint: 'Par exemple 12,50',
        amountInvalid: 'Saisis un montant, par exemple 12,50.',
        amountTooLarge: 'Ce montant est trop élevé.',
        ambiguous: 'Tu veux dire {a} ou {b} ?',
        confirmLarge: '{amount}, c’est bien ça ?',
        confirmLargeYes: 'Oui, c’est ça',
        description: 'Description',
        descriptionHint: 'Tout le monde à la maison le voit',
        paidBy: 'Payé par',
        date: 'Date',
        dateFuture: 'Une date dans le futur n’est pas possible.',
        dateLocked: 'Cette période est clôturée (jusqu’au {date}).',
        split: 'Répartition',
        splitEqual: 'À parts égales',
        splitWeights: 'Au prorata',
        splitExact: 'Exact',
        splitDinner: 'Convives du {date}',
        splitDinnerHint: 'Réparti entre celles et ceux qui ont mangé ; les invités comptent pour qui les a amenés.',
        remaining: 'encore {amount} à répartir',
        tooMuch: '{amount} de trop',
        perPerson: 'Par personne',
        nobody: 'Choisis au moins une personne.',
        enteredBy: 'saisi par {name}',
        editedBy: 'modifié par {name} le {date}',
        edit: 'Modifier',
        delete: 'Supprimer',
        deleteConfirm: 'Tu es sûr·e ?',
        deleteBody: 'Tu peux la restaurer pendant 30 jours.',
        deleted: 'Supprimée',
        restore: 'Restaurer',
        restored: 'Restaurée',
        question: 'Quelque chose ne va pas ?',
        questionAsked: 'Ta question est notée sur la dépense.',
        questionOpen: '{name} demande si c’est correct',
        questionResolve: 'C’est correct',
        questionAdjust: 'Ajuster',
        questionWithdraw: 'Retirer la question',
        detailTitle: 'Dépense',
        lockedNote: 'Cette dépense fait partie d’une période clôturée.',
        gets: 'doit encore recevoir {amount}',
        owes: 'doit encore régler {amount}',
        even: 'est à zéro',
        twoHomeOpen: 'encore à régler : {amount}',
        suggestions: 'Proposition de règlement',
        suggestionLine: '{from} → {to} {amount}',
        copy: 'Copier le texte',
        copied: 'Copié',
        iPaid: 'J’ai payé',
        wasPaid: 'C’est payé',
        settleTitle: 'Règlement',
        settleHint: 'Aucun argent ne passe par AMUMIN ; ce n’est qu’une note.',
        settleSaved: 'Noté. {name} doit encore le confirmer.',
        settleSavedConfirmed: 'Noté.',
        pending: 'Règlements en attente',
        pendingLine: '{from} indique avoir payé {amount}',
        confirm: 'C’est correct',
        reject: 'Ce n’est pas correct',
        waiting: 'en attente de {name}',
        confirmed: 'confirmé',
        unconfirmed: 'non confirmé',
        noLogins: '{names} n’ont pas encore leur propre connexion. Tant qu’ils n’ont pas accepté l’invitation, tu gères leurs dépenses et un remboursement vers eux compte tout de suite (non confirmé).',
        noLoginsOne: '{names} n’a pas encore sa propre connexion. Tant que l’invitation n’est pas acceptée, tu gères les dépenses et un remboursement compte tout de suite (non confirmé).',
        inviteHousemates: 'Inviter les colocataires',
        removeSettlement: 'Retirer',
        carried: 'Solde reporté',
        closeTitle: 'Clôturer une période',
        closeBody: 'Clôturer jusqu’au {date}.',
        closeHelp: 'Les soldes ouverts sont reportés. Les lignes plus anciennes sont verrouillées et supprimées 24 mois après leur date.',
        closeButton: 'Clôturer jusqu’au {date}',
        closeQuestions: 'D’abord répondre aux questions ouvertes ({n}).',
        closePending: 'D’abord les règlements en attente ({n}).',
        closeNothing: 'Rien à clôturer pour l’instant.',
        closed: 'Clôturé jusqu’au {date}',
        lastClosed: 'Dernière clôture jusqu’au {date}',
        allSettled: 'Tout est réglé',
        exportCsv: 'Exporter en CSV',
        settledEmpty: 'Pas encore de règlements.',
        leaverWarn: '{name} a encore {amount} ouvert.',
        leaverHint: 'Réglez cela d’abord, ou mettez-vous d’accord ensemble. Le solde reste dans l’aperçu.',
        offWarn: 'Partager les frais va être désactivé. Les données sont conservées 12 mois puis supprimées.',
        widgetGets: 'Tu dois encore recevoir {amount}',
        widgetOwes: 'Tu dois encore régler {amount}',
        widgetEven: 'Tout est réglé',
        widgetAll: 'Vers les frais',
        twoHomeConfirm: 'Fonctionne si vous êtes tous les deux parents dans ce foyer. Les enfants ne voient rien.',
        twoHomeConfirmYes: 'Activer',
    },
    bookings: {
        intro: 'Lave-linge, sèche-linge, salle ou lit d’appoint : vois qui en a besoin et quand.',
        empty: 'Rien à réserver pour l’instant.',
        emptyBody: 'Choisis ce que vous partagez. Tu pourras modifier les règles plus tard.',
        addKind: '+ {name}',
        day: 'Jour',
        prevDay: 'Jour précédent',
        nextDay: 'Jour suivant',
        today: 'Aujourd’hui',
        free: 'libre',
        mine: 'toi',
        closedHours: 'fermé',
        dstHour: 'changement d’heure',
        tapFree: 'Touche un créneau libre pour réserver.',
        sheetTitle: 'Réserver : {resource}',
        start: 'Début à',
        duration: 'Durée',
        forWho: 'Pour qui',
        book: 'Réserver',
        booked: '{resource} {time} réservé',
        fromDate: 'Du',
        toDate: 'Jusqu’au (inclus)',
        maxNights: 'Au maximum {n} nuits d’affilée.',
        overlap: 'À {time}, c’est déjà le tour de {name}. Prochain créneau libre : {next}.',
        overlapNoNext: 'Ce créneau est déjà réservé.',
        takeNext: 'Prendre {time}',
        err: {
            past: 'Ce créneau est déjà passé.',
            max_days_ahead: 'On peut réserver jusqu’à {n} jours à l’avance.',
            slot: 'Choisis un horaire sur la grille de {n} minutes.',
            dst_hour: 'Cet horaire tombe pendant le changement d’heure. Choisis-en un autre.',
            max_minutes: 'Au maximum {duration} d’affilée.',
            closed_hours: '{resource} : disponible de {from} à {until}.',
            quota: 'Tu as déjà {n} réservations cette semaine pour : {resource}.',
            max_days: 'Au maximum {n} jours d’affilée.',
        },
        myTitle: 'Mes réservations',
        myEmpty: 'Tu n’as rien réservé.',
        cancel: 'Annuler',
        cancelled: 'Annulée',
        done: 'Terminé, libérer',
        freed: 'De nouveau libre',
        viaBoard: 'via le tableau',
        cancelledBoard: 'annulée via le tableau, {time}',
        manage: 'Gérer',
        manageTitle: 'Choses à réserver',
        addThing: 'Ajouter une chose',
        editThing: 'Modifier : {name}',
        name: 'Nom',
        kind: 'Type',
        unit: 'Réserver par',
        unitSlot: 'créneau',
        unitDay: 'journée entière',
        slotMinutes: 'Créneau',
        defaultMinutes: 'Durée par défaut',
        maxMinutes: 'Au maximum d’affilée',
        maxDays: 'Jours d’affilée au maximum',
        maxAhead: 'Réserver à l’avance (jours)',
        perWeek: 'Par personne et par semaine',
        perWeekNone: 'Sans limite',
        openFrom: 'Ouvert de',
        openUntil: 'Ouvert jusqu’à',
        alwaysOpen: 'Toujours ouvert',
        onBoard: 'Sur le tableau de l’entrée',
        archive: 'Archiver',
        unarchive: 'Restaurer',
        archived: 'Archivé',
        minutes: '{n} min',
        hours: '{n} h',
        widgetNext: 'Toi : {resource} {time}',
        widgetFreeNow: '{resource} : libre maintenant',
        widgetBusyUntil: '{resource} : occupé jusqu’à {time}',
        widgetAll: 'Vers les réservations',
        kinds: {
            washer: 'Lave-linge',
            dryer: 'Sèche-linge',
            room: 'Salle',
            guest_bed: 'Lit d’appoint',
            other: 'Autre',
        },
    },
    setup: {
        residents: 'Combien êtes-vous ?',
        residentsLess: 'Moins',
        residentsMore: 'Plus',
        shares: 'Que partagez-vous ?',
        shareNames: {
            kitchen: 'Cuisine',
            bathroom: 'Salle de bain',
            laundry: 'Lave-linge',
            dryer: 'Sèche-linge',
            common_room: 'Salle commune',
            guest_bed: 'Lit d’appoint',
            groceries: 'Courses',
            costs: 'Frais',
        },
        sameRights: 'Les colocataires ont les mêmes droits que toi.',
        housemates: 'Colocataires',
        housematesHint: 'Leurs prénoms : ils apparaissent tout de suite dans le planning et la liste des repas.',
        housemateName: 'Prénom du colocataire {n}',
        housematesAdd: 'Ajouter les colocataires',
        housematesAdded: 'Colocataires ajoutés : {n}',
        housemateEmail: 'E-mail du colocataire {n} (facultatif)',
        invitesSent: 'Invitations envoyées : {n}',
        invitesLater: 'Pas encore invité. Tu peux le faire plus tard dans Colocataires.',
        oneByOne: 'Ou une seule personne (par exemple un enfant ou une nounou)',
        planTitle: 'Voici comment nous installons la maison',
        planBody: 'Ceci est ajouté. Rien n’est jamais retiré ; ce qui existe déjà reste tel quel.',
        planRooms: 'Pièces : {list}',
        planDuties: 'Planning : {list}',
        planResources: 'Réservations : {list}',
        planDinner: 'Liste des repas : inscription jusqu’à {time}',
        run: 'Installer la maison',
        again: 'Réinstaller',
        againHint: 'Ajoute seulement ce qui manque. Rien n’est retiré.',
        doneToast: 'La maison est installée.',
        nothingNew: 'Tout était déjà là.',
        offTitle: 'Un module avec des données va être désactivé',
        offDinner: 'Qui mange va être désactivé. Les données sont conservées 12 mois puis supprimées.',
        offBookings: 'Réservations va être désactivé. Les données sont conservées 12 mois puis supprimées.',
        csv: 'Télécharger les frais en CSV',
    },
    push: {
        dinner: 'Qui mange',
        dinnerHint: '« Tu manges avec nous ? » avant l’heure limite, et la cuisine sait qui vient.',
        bookings: 'Réservations',
        bookingsHint: 'Ta réservation commence bientôt, ou quelqu’un a annulé sur le tableau.',
    },
    // Ronde 1 golf 8 (ON-3): huisgenoten per e-mail uitnodigen.
    invite: {
        title: 'Inviter {name}',
        body: '{name} reçoit un e-mail avec un lien et choisit son mot de passe. Les colocataires ont les mêmes droits que toi.',
        email: 'Adresse e-mail',
        send: 'Envoyer l’invitation',
        sent: 'Invitation envoyée à {email}',
        pending: 'Invité : {email}',
        resend: 'Renvoyer',
        taken: 'Cette personne a déjà sa propre connexion.',
        already: 'Cette adresse fait déjà partie de ce foyer.',
        limit: 'Vingt invitations ont déjà été envoyées aujourd’hui. Réessaie demain.',
        inUse: 'Cette adresse a déjà une invitation pour suivre. Retire-la d’abord.',
        loginNew: 'Connecte-toi avec ton nouveau mot de passe. Ton adresse e-mail est déjà remplie.',
        hint: 'Pas encore de connexion : {names}. Touche un nom pour inviter cette personne par e-mail.',
        landingTitle: 'Invitation dans ton foyer',
        landingBody: '{inviter} t’invite dans {household}. Tu y figures en tant que {member}.',
        accepted: 'Bienvenue dans {household}. Tu peux maintenant utiliser l’application.',
    },
};
//# sourceMappingURL=samenApp.fr.js.map